import React, { useState, useCallback, useMemo, memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import EnhancedTable from "@/components/common/EnhancedTable"
import Box from "@material-ui/core/Box"
import { useDispatch, useSelector } from "react-redux"
import StickyHeadTable from "@/components/common/StickyHeadTable"

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(3),
    },
}))

const ViewDesignationTable = memo((props) => {
    const { designationData, handleEditClickOpen, handleSetViewDesignationEditDetail } = props
    const classes = useStyles()
    const [columns, setColumns] = useState(() => [{ id: "designation", label: "Designation Name", minWidth: 50 }])

    const designationEditItem = useCallback((e, rowData) => {
        e.stopPropagation()
        const { designationId, companyId, designation } = rowData
        handleSetViewDesignationEditDetail({
            display: true,
            designationId,
            companyId,
            designation,
        })
        handleEditClickOpen()
    }, [])

    return (
        <Box mt={1} className={classes.participantNoRoleListTableWrapper}>
            <StickyHeadTable
                columns={columns}
                rows={[...designationData.data.generalDesignation, ...designationData.data.companyUniqueDesignation]}
                tableTitle="Current Designation"
            />
        </Box>
    )
})

export default ViewDesignationTable
